var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Insight",
    transform: "translate(-242 -194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8610",
    "data-name": "Rectangle 8610",
    width: 18,
    height: 18,
    transform: "translate(242 194)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18061",
    "data-name": "Group 18061",
    transform: "translate(-469.5 33.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_73",
    "data-name": "Line 73",
    d: "M0,5.768a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V4.768A1,1,0,0,1,0,5.768Z",
    transform: "translate(716.5 167.884)",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_75",
    "data-name": "Line 75",
    d: "M0,8.152a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V7.152A1,1,0,0,1,0,8.152Z",
    transform: "translate(722.21 165.5)",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_76",
    "data-name": "Line 76",
    d: "M0,4.815a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V3.815A1,1,0,0,1,0,4.815Z",
    transform: "translate(725.065 168.838)",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_74",
    "data-name": "Line 74",
    d: "M0,3.384a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V2.384A1,1,0,0,1,0,3.384Z",
    transform: "translate(719.355 170.268)",
    fill: "#1b1c1d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsight);
export default __webpack_public_path__ + "static/media/insight.2d5a473ef480aa9530321eea36c51448.svg";
export { ForwardRef as ReactComponent };